import * as projectUtils from "@restaurant-store-utils";

import { type RestaurantDetails } from "../gql/getters/restaurantDetails";
import type { RegularAvailabilityConfig } from "../model/types";
import type { NonEmptyArray } from "../types";

interface Utils {
  batcher<BatchElement>(
    processBatch: (_currentBatch: BatchElement[]) => void,
    period: number,
  ): (batchElement: BatchElement) => Promise<void>;
  decodeRegularAvailabilityConfiguration: (
    configurationJSON: RestaurantDetails["configurationJSON"],
  ) => RegularAvailabilityConfig;
  formatTime(time: number): string;
  getFirst<T>(array: T[]): T | undefined;
  getLast<T>(array: T[]): T | undefined;
  isPast(date: Date | string): boolean;
  isServer(): boolean;
  removeSessionSelectedRestaurantId(): void;
  removeSessionViewState(): void;
  sessionsMatch(
    session1: string | null | undefined,
    session2: string | null | undefined,
  ): boolean;
  timeOfBooking(date: string): string | false;
  wait(ms: number): Promise<void>;
  readonly DATE_FORMAT: string;
  isNonEmpty<A>(array: readonly A[]): array is NonEmptyArray<A>;
}

export const {
  batcher,
  decodeRegularAvailabilityConfiguration,
  formatTime,
  getFirst,
  getLast,
  isPast,
  isServer,
  removeSessionSelectedRestaurantId,
  removeSessionViewState,
  sessionsMatch,
  timeOfBooking,
  wait,
  DATE_FORMAT,
  isNonEmpty,
} = projectUtils satisfies Utils;
